/**
 * @flow
 * @relayHash 0516d058655fef31ca70b87da01fb368
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TrackerDestination = "LOGGI" | "RECIPIENT" | "SENDER" | "%future added value";
export type updateStatusQueryVariables = {|
  packageId: number
|};
export type updateStatusQueryResponse = {|
  +privatePackageTracker: ?{|
    +currentStatus: ?{|
      +error: ?number,
      +inProgress: ?boolean,
      +destination: ?TrackerDestination,
    |},
    +relativeEta: ?number,
    +currentDriverPosition: ?{|
      +lat: number,
      +lng: number,
    |},
    +driverInfo: ?{|
      +firstName: string,
      +photoUrl: {|
        +default: ?string
      |},
    |},
  |}
|};
export type updateStatusQuery = {|
  variables: updateStatusQueryVariables,
  response: updateStatusQueryResponse,
|};
*/

/*
query updateStatusQuery(
  $packageId: Int!
) {
  privatePackageTracker(packageId: $packageId) {
    currentStatus {
      error
      inProgress
      destination
    }
    relativeEta
    currentDriverPosition {
      lat
      lng
    }
    driverInfo {
      firstName
      photoUrl {
        default
      }
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'packageId',
        type: 'Int!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'privatePackageTracker',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'packageId',
            variableName: 'packageId'
          }
        ],
        concreteType: 'PrivateTrackerResultNode',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'currentStatus',
            storageKey: null,
            args: null,
            concreteType: 'TrackerStatusNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'error',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'inProgress',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'destination',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'relativeEta',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'currentDriverPosition',
            storageKey: null,
            args: null,
            concreteType: 'CurrentDriverPositionNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'lat',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'lng',
                args: null,
                storageKey: null
              }
            ]
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'driverInfo',
            storageKey: null,
            args: null,
            concreteType: 'DriverPublicNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'firstName',
                args: null,
                storageKey: null
              },
              {
                kind: 'LinkedField',
                alias: null,
                name: 'photoUrl',
                storageKey: null,
                args: null,
                concreteType: 'PhotoUrlType',
                plural: false,
                selections: [
                  {
                    kind: 'ScalarField',
                    alias: null,
                    name: 'default',
                    args: null,
                    storageKey: null
                  }
                ]
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'updateStatusQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'updateStatusQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'updateStatusQuery',
      id: null,
      text:
        'query updateStatusQuery(\n  $packageId: Int!\n) {\n  privatePackageTracker(packageId: $packageId) {\n    currentStatus {\n      error\n      inProgress\n      destination\n    }\n    relativeEta\n    currentDriverPosition {\n      lat\n      lng\n    }\n    driverInfo {\n      firstName\n      photoUrl {\n        default\n      }\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '394cc4329270256c24f2f97bd1e8b832';
module.exports = node;
